import * as PropTypes from 'prop-types';
import * as React from 'react';
import * as classNames from 'classnames';

const AcceptedPaymentMethod = ({ paymentMethod }) => (
  <div className={classNames('payment-method-icon', `payment-method-icon--${paymentMethod}`)}>
    <span className="payment-method-icon__label">
      {I18n.t(`acceptedPaymentMethods.${paymentMethod}`)}
    </span>
  </div>
);

AcceptedPaymentMethod.propTypes = {
  paymentMethod: PropTypes.string.isRequired,
};

export default AcceptedPaymentMethod;



// WEBPACK FOOTER //
// ./javascripts/components/accepted_payment_methods/accepted_payment_method.jsx